import styled from 'styled-components';
import Utility from '../../../../util/utilityfunctions';

export default styled.section`
	display: flex;
	flex-flow: column;
	align-items: flex-end;
	font-size: 1.4rem;
	/* Prevent blinking effect on Canvas Client Portal tab, when "Export Data" is clicked. */
	.motif-text-alt-button.motif-text-button-disabled {
		--btn-link-alt--border-style: var(--btn-link-alt-active--border-style);
	}
`;
